import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const LANGS = [
  { code: "en", label: "English" },
  { code: "id", label: "Bahasa Indonesia" },
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="lang-switcher"
          className="flex items-center gap-2 px-3 py-2 rounded-full text-xs text-slate-700 hover:bg-slate-50 border border-transparent hover:border-slate-200 transition-colors"
        >
          <Globe size={14} strokeWidth={1.5} />
          <span className="uppercase font-medium tracking-wider">{current.code}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48 bg-white border-slate-100 shadow-xl rounded-2xl">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-${l.code}`}
            onClick={() => i18n.changeLanguage(l.code)}
            className={`cursor-pointer text-sm rounded-xl ${current.code === l.code ? "bg-slate-50 font-medium" : ""}`}
          >
            <span className="uppercase text-xs tracking-wider text-seafoam mr-3">{l.code}</span>
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
